(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/fetch-draw-analyses-by-hook.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/fetch-draw-analyses-by-hook.js');
"use strict";


const useFetchAnalysesByDraw = svs.components.sportinfo.gameAnalysesRedux.hooks.useFetchAnalysesByDraw;

const FetchDrawAnalysesByHook = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  useFetchAnalysesByDraw(drawNumber, productId);
  return null;
};
FetchDrawAnalysesByHook.propTypes = {
  drawNumber: PropTypes.number,
  productId: PropTypes.number
};
setGlobal('svs.components.tipsen.hooks.FetchDrawAnalysesByHook', FetchDrawAnalysesByHook);

 })(window);